import React from 'react';
import { useTranslation } from 'react-i18next';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { useBudget } from '../../context/BudgetContext';
import { setDebtStrategy } from '../../context/budgetActions';

export default function DebtStrategyToggle() {
  const { t } = useTranslation();
  const { state, dispatch } = useBudget();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      <Typography variant="subtitle2" color="text.secondary">
        {t('budgetPlanner.debt.strategy', 'Estrategia')}:
      </Typography>
      <ToggleButtonGroup
        value={state.debtStrategy}
        exclusive
        onChange={(_, val) => { if (val) dispatch(setDebtStrategy(val)); }}
        size="small"
      >
        <Tooltip title={t('budgetPlanner.debt.avalancheDesc', 'Paga primero la deuda con mayor tasa de interés. Ahorra más en intereses.')}>
          <ToggleButton value="avalanche" sx={{ textTransform: 'none' }}>
            {t('budgetPlanner.debt.avalanche', 'Avalancha')}
          </ToggleButton>
        </Tooltip>
        <Tooltip title={t('budgetPlanner.debt.snowballDesc', 'Paga primero la deuda más pequeña. Genera motivación con victorias rápidas.')}>
          <ToggleButton value="snowball" sx={{ textTransform: 'none' }}>
            {t('budgetPlanner.debt.snowball', 'Bola de nieve')}
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    </Box>
  );
}
